import CallCenterCallModel from './call-center-call.model';
import CallCenterUserModel from './call-center-user.model';

export default class CallCenterOverviewModel {
  usuario!: CallCenterUserModel;

  ligacoes!: CallCenterCallModel[];
}
